"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("./Button"));
var _react = _interopRequireDefault(require("react"));
var _FlexRow = require("../../layout/flex/FlexRow");
var _DropdownList = _interopRequireDefault(require("../dropdown/DropdownList"));
var _jsxRuntime = require("react/jsx-runtime");
var SplitButton = function SplitButton(props) {
  var children = props.children;
  var childrenWithProps = _react.default.Children.map(children, function (child, index) {
    var childNode = child;
    if (index === 0) {
      return /*#__PURE__*/_react.default.cloneElement(childNode, {
        borderRadiusSide: 'left'
      });
    }
    if (index === children.length - 1) {
      return /*#__PURE__*/_react.default.cloneElement(childNode, {
        borderRadiusSide: 'right'
      });
    }
    return childNode;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexRow.FlexRow, {
    gap: "xxs",
    flex: "0",
    children: childrenWithProps
  });
};
var SplitButtonSection = function SplitButtonSection(props) {
  var text = props.text,
    contextMenuOptions = props.dropdownMenuOptions,
    rest = _objectWithoutProperties(props, ["text", "dropdownMenuOptions"]);
  return contextMenuOptions && contextMenuOptions.length ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DropdownList.default, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Trigger, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, _objectSpread({
        borderRadiusSide: "none"
      }, rest, {
        "data-cy": 'split-button-dropdown-list-trigger',
        children: text || ''
      }))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Content, {
      children: contextMenuOptions.map(function (option) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Item, {
          onClick: option.onClick,
          "data-cy": "split-button-dropdown-list-option-" + option.name.toLowerCase().replace(/ /g, '-'),
          children: option.name
        });
      })
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, _objectSpread({
    borderRadiusSide: "none"
  }, rest, {
    "data-cy": 'split-button-section',
    children: text || ''
  }));
};
SplitButton.Section = SplitButtonSection;
var _default = exports.default = SplitButton;